import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconWorldStyle0 = stylesCss;

const BiIconWorld$1 = /*@__PURE__*/ proxyCustomElement(class BiIconWorld extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '4f4bffee4b6772676a91a4ebb739757696fe61a2', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '059b32dae543d76ecd53dff07ff84b8d056e3475', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '5d446f2e68afdec8a6bcea73c6b24d6482fa1626', "fill-rule": 'evenodd', d: 'M5.674 10.41a7.5 7.5 0 0 0-.313 2.15c0 .75.11 1.473.314 2.155h2.417a16.8 16.8 0 0 1-.136-2.155c0-.738.047-1.459.136-2.15zm.633-1.5h2.055a11.4 11.4 0 0 1 .891-2.52 8.2 8.2 0 0 1 .315-.57 7.533 7.533 0 0 0-3.26 3.09Zm6.554-5.35a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 1.5c-.713 0-1.558.593-2.268 2.004a9.6 9.6 0 0 0-.685 1.847h5.906a9.6 9.6 0 0 0-.685-1.847c-.71-1.41-1.555-2.003-2.268-2.003Zm4.499 3.85a11.44 11.44 0 0 0-.891-2.52 8.2 8.2 0 0 0-.316-.57 7.533 7.533 0 0 1 3.261 3.09zm-1.244 1.5h-6.51c-.097.68-.15 1.4-.15 2.15 0 .752.053 1.475.15 2.155h6.51c.097-.68.15-1.403.15-2.155 0-.75-.053-1.47-.15-2.15m1.513 4.306c.09-.693.137-1.415.137-2.155s-.047-1.46-.136-2.15h2.418a7.5 7.5 0 0 1 .313 2.15 7.5 7.5 0 0 1-.314 2.155zm-1.817 1.5H9.91c.183.688.415 1.308.684 1.84.71 1.412 1.555 2.005 2.268 2.005s1.557-.593 2.268-2.004a9.56 9.56 0 0 0 .683-1.841Zm.341 3.085a8.2 8.2 0 0 0 .316-.57c.37-.734.67-1.584.89-2.516h2.052a7.533 7.533 0 0 1-3.258 3.086m-6.585 0a8.2 8.2 0 0 1-.315-.57 11.43 11.43 0 0 1-.89-2.516H6.31a7.533 7.533 0 0 0 3.258 3.086', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconWorldStyle0; }
}, [1, "bi-icon-world", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-world"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-world":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconWorld$1);
            }
            break;
    } });
}

const BiIconWorld = BiIconWorld$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconWorld, defineCustomElement };
